import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useSelectAllScenarioGrants = () => {
  const { mutate: selectAllGrants, isPending } = useAppMutation([QueryKey.CREATE_SCENARIO_GRANT], {
    mutationFn: ({ scenarioId, sarOnly }: { sarOnly?: boolean; scenarioId: string }) =>
      ApiService.post(
        {
          endpoint: BackendRoute.SCENARIOS,
          routePath: [scenarioId, 'grants-for-scenario', 'exercise-all'],
        },
        {
          queryParams: {
            sarOnly: sarOnly || undefined,
          },
        },
      ),
  });
  return { selectAllGrants, isPending };
};
